interface OpenWhatsAppWeb {
  url: string
  text?: string
}

export const openWhatsAppWeb = (input: OpenWhatsAppWeb) => {
  let { url, text } = input
  if (text) {
    url += `&text=${text}`
  }
  open(url, '_blank')
}
